import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { COLOR, FIXED_INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
} from '../Button.h'

export interface ISecondaryFontButton1ButtonProps extends IButtonProps {}

export const SecondaryFontButton1Button = ({
  title = '',
  corners = ButtonCorners.CORNERS_PILL,
  paddings = [FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_100],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_TEXT_TERTIARY,
  backgroundColorDefault = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorHovered = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_DARK_25,
  backgroundColorDisabled = COLOR.SURFACE_DARK_5,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.FontSmBold,
  fluid = ButtonFluid.None,
  ...rest
}: ISecondaryFontButton1ButtonProps): JSX.Element | null =>
  title ? (
    <Button
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      title={title}
      {...rest}
    />
  ) : null
